// extracted by mini-css-extract-plugin
export default {"wrapper":"scrollableContainerDesktop-module__wrapper__cYxEU"};